import { render } from "./BNPLInformation.vue?vue&type=template&id=791377a0&scoped=true"
import script from "./BNPLInformation.vue?vue&type=script&lang=js"
export * from "./BNPLInformation.vue?vue&type=script&lang=js"

import "./BNPLInformation.vue?vue&type=style&index=0&id=791377a0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791377a0"]])

export default __exports__